//ADD INTREST
export const ADD_INTEREST_REQUEST = "ADD_INTEREST_REQUEST";
export const ADD_INTEREST_SUCCESS = "ADD_INTEREST_SUCCESS";
export const ADD_INTEREST_FAILURE = "ADD_INTEREST_FAILURE";

//UPDATE INTREST
export const UPDATE_INTEREST_REQUEST = "UPDATE_INTEREST_REQUEST";
export const UPDATE_INTEREST_SUCCESS = "UPDATE_INTEREST_SUCCESS";
export const UPDATE_INTEREST_FAILURE = "UPDATE_INTEREST_FAILURE";

//DELETE INTREST
export const DELETE_INTEREST_REQUEST = "DELETE_INTEREST_REQUEST";
export const DELETE_INTEREST_SUCCESS = "DELETE_INTEREST_SUCCESS";
export const DELETE_INTEREST_FAILURE = "DELETE_INTEREST_FAILURE";

//GET INTREST LIST
export const GET_INTEREST_REQUEST = "GET_INTEREST_REQUEST";
export const GET_INTEREST_SUCCESS = "GET_INTEREST_SUCCESS";
export const GET_INTEREST_FAILURE = "GET_INTEREST_FAILURE";
